<template>
  <div class="main-pc">
    <div class="header">
      <img src="~@/assets/img/pc/banner.jpg" alt>
    </div>
    <div class="container">
      <div class="img-block block1">
        <img src="~@/assets/img/pc/PC1.png" alt>
      </div>
      <!--  -->
      <div
        class="img-block"
        :class="'block' + (index+2)"
        v-for="(item,index) in songList"
        :key="index"
      >
        <img :src="`${require('@/assets/img/pc/'+item.imgUrl)}`" alt>
        <!-- 歌手头像热区 -->
        <div 
          class="singerImg"
          @click="goSinger(item.singerUrl)"
          :class="{
            left: (index+2)%2 == 0,
            right: (index+2)%2 != 0,
          }">
        </div>
        <!-- 关注 -->
        <div
          class="attention-icon"
          @click="goSinger(item.singerUrl)"
          :class="{
            left: (index+2)%2 != 0,
            right: (index+2)%2 == 0,
          }"
        >
          <img src="~@/assets/img/pc/attention.png" alt>
        </div>
        <!-- 专辑热区 -->
        <div 
          class="albumImg"
          @click="goAlbum"
          :class="{
            left: (index+2)%2 != 0,
            right: (index+2)%2 == 0,
          }">
        </div>
        <!-- 播放按钮 -->
        <div
          class="play-icon play"
          :class="{
            pause:state == 'playing' && +currId == item.id.qqyin,
            left: (index+2)%2 != 0,
            right: (index+2)%2 == 0,
          }"
          @click="play(item.id)"
        ></div>
      </div>
    </div>
    <div class="footer">
      <div class="img-block block12">
        <img src="~@/assets/img/pc/PC12.png" alt>
      </div>
    </div>
  </div>
</template>
<script>
import '@/libs/qqyin/qqmusic_h5';
import os, { plantForm } from '@/utils';
import songList from '@/data/pc'
require('_a/styles/pc_base.less');
export default {
  components: {
    // musicCom: () => import('_c/music/index.vue')
  },
  name: 'home',
  data() {
    return {
      songList,
      player: '',
      state: '',
      currId: ''
    };
  },
  methods: {
    play(songID) {
      // console.log(songID[plantForm])
      // console.log(this.player)
      // this.player.play(songID[plantForm]+'')
      this.player.play(songID[plantForm]);
    },
    goSinger(singerUrl) {
      const url = singerUrl[plantForm]
      if (!url) {
        return;
      }
      window.location.href = url;
    },
    goAlbum() {
      window.location.href = 'https://y.qq.com/n/yqq/album/003GFD1D232z4m.html'
    },
    initPlayer() {
      this.player = new window.Player();
      this.player.on('play', (el) => {
        this.state = el.state;
        this.currId = el.song.id;
        // console.log(el)
        // console.log(this.state)
      });
      this.player.on('pause', (el) => {
        this.state = el.state;
        // console.log(this.state)
      });
    }
  },
  created() {
    this.initPlayer();
  }
};
</script>

<style lang="less" scoped>
.main-pc {
  min-width: 1200px;
  .img-block {
    position: relative;
    &.block5 {
      .attention-icon {
        right: 255px;
      }
    }
    &.block6 {
      .attention-icon {
        left: 447px;
      }
    }
    &.block7 {
      .attention-icon {
        right: 345px;
      }
    }
    &.block8 {
      .attention-icon {
        left: 443px;
      }
    }
    &.block9 {
      .attention-icon {
        right: 256px;
      }
    }
    &.block11 {
      .attention-icon {
        right: 345px;
      }
    }
  }
  .play-icon {
    position: absolute;
    width: 49px;
    height: 49px;
    background-position: center center;
    background-size: 100% 100%;
    z-index: 5;
    cursor: pointer;

    &.left {
      left: 482px;
      bottom: 97px;
    }
    &.right {
      right: 390px;
      bottom: 97px;
    }
    &.play {
      background-image: url("~@/assets/img/pc/play.png");
    }
    &.pause {
      background-image: url("~@/assets/img/pc/pause.png");
    }
  }
  .singerImg{
    width: 500px;
    height: 170px;
    position: absolute;
    z-index: 2;
    cursor: pointer;
    &.left {
      top: 40px;
      left: 50px;
    }
    &.right {
      top: 40px;
      right: 50px;
    }
  }
  .albumImg{
    width: 500px;
    height: 160px;
    position: absolute;
    z-index: 2;
    cursor: pointer;
    &.right {
      top: 194px;
      right: 40px;
    }
    &.left {
      top: 193px;
      left: 40px;
    }
    
  }
  .attention-icon {
    width: 80px;
    height: 30px;
    position: absolute;
    z-index: 5;
    cursor: pointer;
    &.left {
      right: 297px;
      bottom: 265px;
    }
    &.right {
      left: 353px;
      bottom: 265px;
    }
  }
  .header {
    height: 846px;
    background-color: #666;
    overflow-x: hidden;
    img {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .container {
    width: 1200px;
    margin: 0 auto;
  }
  .footer {
    overflow-x: hidden;
    .block12 {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
